
import React, { useEffect,useState,useRef } from 'react';
import {Modal,message,Button,Popover } from 'antd'
import {api_oplog_list} from '../../api';
import { ProTable } from '@ant-design/pro-components';
import Icon,{ DatabaseOutlined } from '@ant-design/icons';
// import StatusColumn from './statuscolumn.jsx';
// import Communications from './communications.jsx';

const screenHeight = document.body.clientHeight;
// const screenWidth = document.body.clientWidth;

const App = (props) => {
    const {showModal, rowInfo, closeModal, from} = props;
    // console.log('-------invitationStatusEnum----------- ', invitationStatusEnum)
    const actionRef = useRef();

    // const [tableData, setTableData] = useState([]);
    // const [statusEnum, setStatusEnum] = useState({});

    const CallDrop = ({messages}) => {
      console.log('messages - ', messages, messages.length)
      return (
          <div style={{ width: '400px', maxHeight:screenHeight*0.9, overflowY:"auto", padding: '16px', margin: '0 auto', }}>
              {
                messages.length==undefined ? 
                  Object.keys(messages).map(key=>(
                    <p>{key}: {Array.isArray(messages[key])?JSON.stringify(messages[key]):messages[key]}</p>
                  )) :
                  messages.map(value=>(
                    <p>{value.replace("=",": ")}</p>
                  ))
              }
          </div>
      );
    };

    const columns = [
        {
          title: '操作时间',
          dataIndex: 'creat_time',
          key: 'creat_time',
          width: 150,
        },
        {
          title: '操作用户',
          dataIndex: 'opemail',
          key: 'opemail',
          width: 150,
          ellipsis: true
        },
        {
          title: '操作类型',
          dataIndex: 'type',
          key: 'type',
          width: 100,
        },
        // {
        //   title: '邀约状态',
        //   dataIndex: 'invitation_status',
        //   key: 'invitation_status',
        //   valueType: 'select',
        //   valueEnum: statusEnum,
        //   width: 200,
        //   render: (_, record) => <StatusColumn record={record} valueEnum={statusEnum} />
        // },
        // {
        //   title: '沟通记录',
        //   dataIndex: 'communication_record',
        //   key: 'communication_record',
        //   search: false,
        //   ellipsis: true,
        //   render: (_, record) => {
        //     // console.log('messages 00- ',record, typeof record.communication_record)
        //     let messages=[];
        //     try {
        //       var obj = JSON.parse(record.communication_record.replace(/\n/g,"\\n").replace(/\r/g,"\\r"));
        //       // console.log('=======messages=========',obj)
        //       // console.log('=======messages=========',typeof(obj))
        //       if (obj && typeof obj === "object") 
        //           messages = obj;
        //     } catch (e) {
        //       console.log('=======messages e=========',e)
              
        //     }
        //     return messages.length>0 ? 
        //     <Popover content={<Communications messages={messages} />} title="沟通记录">
        //       <CommunicationIcon />
        //     </Popover>:""
        //     }
        // },
        {
          title: '操作数据',
          dataIndex: 'input',
          key: 'input',
          search: false,
          ellipsis: true,
          render: (_, record) => {
            let messages={};
            try {
              var obj = JSON.parse(record.input);
              if (obj && typeof obj === "object") 
                  messages = obj;
            } catch (e) {
            }
            return Object.keys(messages).length>0 ? 
            <Popover content={<CallDrop messages={messages} />} title="操作数据">
              <DatabaseOutlined />
            </Popover>:""
            }
        },
        {
          title: '操作板块',
          dataIndex: 'from',
          key: 'from',
          width: 100,
        },
        {
          title: '操作接口',
          dataIndex: 'api',
          key: 'api',
          width: 150,
        },
      ];

    useEffect(() => {
        if(showModal && rowInfo.work_order_id)
          actionRef.current?.reload();
            // setTableData(JSON.parse(rowInfo.client_list));
        // else
        //     setTableData([]);
      }, [showModal, rowInfo]);
  
    return (
        <Modal 
            key="scoredetail"
            title={(from=='order'?('工单 '+rowInfo.work_order_id):('候选人 '+rowInfo.name))+' 操作记录'}
            open={showModal}
            width={"60%"}
            bodyStyle={{height:screenHeight*0.5,overflowY:"scroll"}}
            centered
            maskClosable={false}
            footer={[<Button  className="m-btn-white" onClick={closeModal}>
            关闭
            </Button>,] }
            onCancel={closeModal}>

          <ProTable
            // headerTitle="候选人列表"
            columns={columns}
            actionRef={actionRef}
            rowKey="id"
            cardBordered
            defaultSize="small"
            request={async (params, sort, filter) => {
              console.log(params,sort, filter);
              // await waitTime(2000);
              var tableData = [];
              var res = await api_oplog_list(from=='order'?{work_order_id:rowInfo.work_order_id, module:"order"}:{candidate_id:rowInfo.candidate_id, module:"candidate"});
              console.log('api_oplog_list-res-----------------', res);
              if(res.data.code == 9){
                tableData = res.data.list;
              }else
                message.error(res.data.msg);

              return {
                data: tableData,
                // current: res.data.pageNo,
                // pageSize: res.data.pageSize,
                success: true,
                // total: res.data.totalRows,
              };
            }}
            search={false}
            options={{
              reload: false, // 去掉刷新按钮
              density: false, // 去掉密度按钮
              setting: true, // 保留列设置按钮
              setting: {
                listsHeight: 400,
              },
            }}
            style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'auto',overflowY: 'auto'}}  
            scroll={{x:750}}
            columnsState={{
              persistenceKey: 'pro-table-callrecord',
              persistenceType: 'localStorage',
              onChange(value) {
                console.log('value: ', value);
              },
            }}

            // form={{
            //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
            //   syncToUrl: (values, type) => {
            //     if (type === 'get') {
            //       return {
            //         ...values,
            //         created_at: [values.startTime, values.endTime],
            //       };
            //     }
            //     return values;
            //   },
            // }}
            pagination={false}
            // dateFormatter="string"

            toolBarRender={() => []}
          />


        </Modal>
    )
}

export default App